import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Dropdown, Pagination} from 'react-bootstrap';

// ...unchanged imports...

const AdminUsers = (props) => {
  const {
    userList,
    jobData,
    jobPagination,
    handleAddNew,
    handleEdit,
    getUserList,
    isLoading,
  } = props;

  const [activePag, setActivePag] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageItems, setPageItems] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // fetch whenever page or page size changes
  useEffect(() => {
    getUserList(currentPage, pageItems);
  }, [getUserList, currentPage, pageItems]);

  // keep totalPages in sync with server-provided pagination
  useEffect(() => {
    if (jobPagination && jobPagination.length > 0) {
      setTotalPages(jobPagination.length);
      // keep activePag aligned with currentPage
      setActivePag(currentPage - 1);
    }
  }, [jobPagination, currentPage]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      setActivePag(page - 1);
      // single source of truth: fetching happens via useEffect
    }
  };

  // 🔧 remove slicing; let server do paging
  const onClick = (i) => {
    handlePageChange(i + 1);
  };

  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header d-flex justify-content-between'>
          <h4 className='card-title'>Restaurant Admin Users</h4>
          <div>
            <Link className='btn btn-primary font-w600 mb-2 mr-auto' to='#' onClick={handleAddNew}>
              + New User
            </Link>
          </div>
        </div>

        <div className='card-body'>
          <div className='w-100 table-responsive'>
            {isLoading && (
              <div id='preloader-inner'>
                <div className='sk-three-bounce-inner'>
                  <div className='sk-child sk-bounce1'></div>
                  <div className='sk-child sk-bounce2'></div>
                  <div className='sk-child sk-bounce3'></div>
                  <div id='preloader-inner-bg'></div>
                </div>
              </div>
            )}

            <div id='example_wrapper' className='dataTables_wrapper'>
              <table id='example' className='display w-100 dataTable'>
                <thead>
                  <tr role='row'>
                    {(userList?.columns ?? []).map((d, i) => (
                      <th className='text-muted' key={i}>{d}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {jobData?.map((row, rowIdx) => (
                    <tr key={rowIdx}>
                      {row.map((cell, i) => (
                        <td key={i}>
                          {i === 3 ? (
                            cell === 'subadmin' ? 'Admin'
                            : cell === 'rest_staff' ? 'Restaurant Staff'
                            : 'Waiter'
                          ) : i === 0 ? (
                            <img className='rounded-circle' width='35' src={cell} alt='' />
                          ) : (
                            <>
                              {i !== 5 && cell}
                              {i === 5 && (
                                <div className='m-2'>
                                  <Link
                                    to='#'
                                    onClick={() => handleEdit(cell)}
                                    className='btn btn-secondary shadow btn-xs sharp mr-1'
                                  >
                                    <i className='fa fa-pencil'></i>
                                  </Link>
                                </div>
                              )}
                            </>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className='d-flex justify-content-between align-items-center mt-3'>
                {/* Page size */}
                <div className='d-flex align-items-center'>
                  <span className='mr-2'>Items per page:</span>
                  <Dropdown>
                    <Dropdown.Toggle variant='outline-primary' size='sm'>
                      {pageItems}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {[5, 10, 20, 50].map((n) => (
                        <Dropdown.Item
                          key={n}
                          onClick={() => {
                            setPageItems(n);
                            setCurrentPage(1);
                          }}
                        >
                          {n}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                {/* Prev / Next */}
                <div className='d-flex align-items-center mr-3'>
                  <button
                    className='btn btn-sm btn-outline-primary mr-2 '
                    disabled={currentPage === 1 || isLoading}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    <i className='fa fa-chevron-left mr-1'></i> Previous
                  </button>
                  <button
                    className='btn btn-sm btn-outline-primary'
                    disabled={currentPage === totalPages || isLoading}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next <i className='fa fa-chevron-right ml-1'></i>
                  </button>
                </div>

                {/* Numbered pagination */}
                {jobPagination && jobPagination.length > 1 && (
                  <Pagination>
                    <Pagination.First
                      disabled={activePag === 0 || isLoading}
                      onClick={() => onClick(0)}
                    />
                    <Pagination.Prev
                      disabled={activePag === 0 || isLoading}
                      onClick={() => activePag > 0 && onClick(activePag - 1)}
                    />

                    {/* First page */}
                    <Pagination.Item
                      key={0}
                      active={activePag === 0}
                      onClick={() => onClick(0)}
                    >
                      {jobPagination[0]}
                    </Pagination.Item>

                    {/* Ellipsis before middle */}
                    {activePag > 2 && jobPagination.length > 4 && <Pagination.Ellipsis />}

                    {/* Pages around current */}
                    {jobPagination.map((_, i) => {
                      if (
                        i > 0 &&
                        i < jobPagination.length - 1 &&
                        (i === activePag - 1 || i === activePag || i === activePag + 1)
                      ) {
                        return (
                          <Pagination.Item
                            key={i}
                            active={i === activePag}
                            onClick={() => onClick(i)}
                          >
                            {jobPagination[i]}
                          </Pagination.Item>
                        );
                      }
                      return null;
                    })}

                    {/* Ellipsis after middle */}
                    {activePag < jobPagination.length - 3 && jobPagination.length > 4 && (
                      <Pagination.Ellipsis />
                    )}

                    {/* Last page */}
                    <Pagination.Item
                      key={jobPagination.length - 1}
                      active={activePag === jobPagination.length - 1}
                      onClick={() => onClick(jobPagination.length - 1)}
                    >
                      {jobPagination[jobPagination.length - 1]}
                    </Pagination.Item>

                    <Pagination.Next
                      disabled={activePag === jobPagination.length - 1 || isLoading}
                      onClick={() =>
                        activePag + 1 < jobPagination.length && onClick(activePag + 1)
                      }
                    />
                    <Pagination.Last
                      disabled={activePag === jobPagination.length - 1 || isLoading}
                      onClick={() => onClick(jobPagination.length - 1)}
                    />
                  </Pagination>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;

